import { get } from 'lodash-es';
import Axios, { AxiosResponse } from 'axios';
import { isCanceledError } from 'common/utils';

function responseHandler(response: AxiosResponse & { code?: number; message?: string }): ExtendAxioResponse {
  const data = get(response, 'data.data', response.data);
  if (data?.error?.message) {
    return Promise.reject(data.error.message);
  }
  return { ...response, data };
}

function errorHandler(error: any) {
  // Ignore error when request is canceled by user:
  if (isCanceledError(error)) return;
  const data = get(error, 'response.data');
  if (data?.error?.message) {
    return Promise.reject(data.error.message);
  }
}

export const OldTianGongRequestInstance = Axios.create({
  baseURL: '/tiangong',
  timeout: 10 * 60 * 1000, // 10min
});

OldTianGongRequestInstance.interceptors.response.use(responseHandler, errorHandler);
